module.exports = __webpack_public_path__ + "img/copy_url_active.ad94dfac.svg";